module.exports = __webpack_public_path__ + "static/media/Go_City_Darker_Background.c7573fec.jpeg";